export default __webpack_public_path__ + "static/media/loginpage-img.ba6486ad.png";